import React from 'react';
import { FaUser, FaClock } from "react-icons/fa";

export default function RightSidebarBox({data}) {
  return (
    <div className='right-sidebar-box d-flex align-items-center justify-content-between mb-2 light-bg corner-radius py-2 px-3'>
      <div>
        <h6 className='mb-1'>{data.booking_service.title}</h6>
        <div className='d-flex align-items-center'>
          <FaUser size={12} />
          <p className='ms-1 mb-0'>{data.booking_parent.firstName+' '+data.booking_parent.lastName}</p>
        </div>
      </div>
      <div>
        <div className='d-flex justify-content-end'>
          <h6 className='pound-symbol'>£</h6>
          <h5>{data.total}</h5>
        </div>
        <div className='d-flex align-items-center justify-content-end'>
          <FaClock size={12} />
          <p className='ms-1 mb-0'>{data.datedOn}</p>
        </div>
      </div>
    </div>
  )
}
